import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { ICustomerQuotePart } from 'quotes/types';

type ExtendedCostColumnId = Extract<QuotePartColId, 'extPurchaseCost' | 'extStandardCost'>;

interface IProps extends ICellRendererParams {
  columnId: ExtendedCostColumnId;
  getNotes?: (quotePart: ICustomerQuotePart) => string[];
  costDecimals?: number;
}

export const ExtendedCostCell = ({
  columnId,
  getNotes,
  costDecimals = PricingHelper.DEFAULT_COST_DECIMALS,
  ...props
}: IProps) => {
  const data = getAgGridTableCellData(props, columnId);
  const value = props?.value;

  if (!value) {
    return DEFAULT_PLACEHOLDER;
  }

  const notes = data && getNotes ? getNotes(data) : [];

  return <Price amount={value} decimals={costDecimals} fixedDecimals notes={notes} />;
};
